import { api, getAllPages } from "./client";
import type { Service, ServiceRequest } from "@/types/service";

interface ResponseID {
  id: string;
}

export const getServices = () =>
  getAllPages<Service>("/v1/services", { serviceId: null });

export const getService = (id: string) =>
  api.get<Service>(`/v1/services/${id}`, { serviceId: id });

export const createService = (data: ServiceRequest) =>
  api.post<ResponseID>("/v1/services", data, { serviceId: null });

export const updateService = (id: string, data: ServiceRequest) =>
  api.patch<ResponseID>(`/v1/services/${id}`, data, { serviceId: id });

export const deleteService = (id: string) =>
  api.delete<ResponseID>(`/v1/services/${id}`, { serviceId: id });
